<script lang="ts">
	import Icon from "./Icon.svelte";
	import cross from "../../../core/assets/icons/cross.svg?raw";
	import { scrollLockStore } from "../stores/scrollLockStore.js";

	let dialogClass = "";
	export { dialogClass as class };
	export let show = false;
	export let headerClass = "";
	export let closeLabel: string | undefined = undefined;
	export let fullscreenOnMobile = false;
	export let noBackdrop = false;

	let dialog: HTMLDialogElement | null = null;
	$: {
		if (dialog) {
			if (show && !dialog.open) {
				if (noBackdrop) {
					dialog.show();
				} else {
					dialog.showModal();
				}
			}
			if (!show && dialog.open) {
				dialog.close();
			}
		}
	}

	$: {
		if (show && !$scrollLockStore) {
			scrollLockStore.set(true);
		}
	}
	$: {
		if (!show) {
			scrollLockStore.set(show);
		}
	}

	function onClose(): void {
		show = false;
	}

	function closeOnEscape(event: KeyboardEvent): void {
		if (show && noBackdrop && event.key === "Escape") {
			onClose();
		}
	}
</script>

<svelte:window on:keydown={closeOnEscape} />

{#if show && noBackdrop}
	<button
		type="button"
		tabindex="-1"
		aria-hidden="true"
		class="fixed inset-0 z-[8887] size-full cursor-default bg-black/40 {fullscreenOnMobile
			? 'max-[500px]:bg-transparent'
			: ''}"
		on:click={onClose}
	></button>
{/if}
<dialog
	bind:this={dialog}
	class="m-auto bg-transparent backdrop:fixed backdrop:inset-0 backdrop:bg-black/40 open:flex {noBackdrop
		? 'fixed inset-0 z-[8888] max-h-full max-w-full'
		: ''} {fullscreenOnMobile
		? 'max-[500px]:h-dvh max-[500px]:max-h-none max-[500px]:w-screen max-[500px]:max-w-none max-[500px]:backdrop:bg-transparent'
		: ''}"
	on:close={onClose}
>
	<div
		class="m-2 max-h-[calc(100vh-1rem)] overflow-y-auto bg-white p-6 {dialogClass} {fullscreenOnMobile
			? 'max-[500px]:m-0 max-[500px]:h-full max-[500px]:max-h-none max-[500px]:w-full max-[500px]:border-0'
			: ''}"
	>
		<div class="mb-4 flex items-start gap-2 {$$slots.title ? 'justify-between' : 'justify-end'} {headerClass}">
			{#if $$slots.title}
				<slot name="title" />
			{/if}
			<button
				class="group flex shrink-0 items-center gap-2 p-1 {closeLabel ? 'text-ltprimary-300 hover:text-ltprimary' : ''}"
				type="button"
				on:click={onClose}
			>
				{#if closeLabel}
					<span class="font-bahnschrift text-xs font-bold uppercase tracking-wider lg:text-base">{closeLabel}</span>
				{/if}
				<Icon
					icon={cross}
					class="aspect-square h-4 transition-colors duration-300 {!closeLabel ? 'group-hover:text-ltprimary-300' : ''}"
				/>
			</button>
		</div>
		<div class="text-left">
			<slot />
		</div>
		{#if $$slots.actions}
			<div class="mt-8">
				<slot name="actions" />
			</div>
		{/if}
	</div>
</dialog>
